import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import BasicButton from "@/src/components/atom/Button/BasicButton";
import Typo from "@/src/components/atom/Typo";
import Icon from "@/src/components/atom/Icon";
import PublicPageHeader from "@/src/components/organism/PublicPageHeader";
import PublicPageFooter from "@/src/components/molecule/PublicPageFooter";
import PaperAirplaneIcon from "@/src/assets/icons/icon-paper-airplane.svg";
import colorSet from "@/src/styles/color";

const ContactUsSuccessPage: React.FC = () => {
  const { t, i18n } = useTranslation(["contactUs"]);

  useEffect(() => {
    i18n.changeLanguage("ko");
  }, [i18n]);

  return (
    <Layout>
      <SuccessSection>
        <PublicPageHeader />

        <Container>
          <TitleSection>
            <Typo typoType="d3" color="gray1">
              {t("contactUs:successPageTitle")}
            </Typo>
          </TitleSection>

          <ContentCard>
        <IconWrapper>
          <Icon iconSrc={PaperAirplaneIcon} iconSize={80} />
        </IconWrapper>

        <MessageWrapper>
          <MainMessageWrapper>
            <Typo typoType="h2">
              {t("contactUs:successTitle")}
            </Typo>
          </MainMessageWrapper>
          <DescriptionWrapper>
            <Typo typoType="b7m" color="gray1">
              {t("contactUs:successDescription")}
            </Typo>
          </DescriptionWrapper>
        </MessageWrapper>

        <ButtonWrapper>
          <BasicButton
            onClick={() => {
              window.location.href = "https://ecoya-snap-user.ecoya.dev/";
            }}
            buttonGrade="secondary"
            buttonColor="blue"
            buttonSize={40}
          >
            {t("contactUs:goToHome")}
          </BasicButton>
        </ButtonWrapper>
      </ContentCard>
    </Container>

        <PublicPageFooter />
      </SuccessSection>
    </Layout>
  );
};

export default ContactUsSuccessPage;

const Layout = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
`;

const SuccessSection = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  padding: 60px 40px;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0;
  width: 100%;
`;

const ContentCard = styled.div`
  width: 720px;
  background: ${colorSet.white};
  padding: 40px 48px;
  border-radius: 16px;
  box-shadow:
    0px 0px 0px 1px rgba(0, 0, 0, 0.1),
    0px 4px 16px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  justify-content: center;
`;

const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  text-align: center;
  width: 100%;
`;

const MainMessageWrapper = styled.div`
  width: 100%;

  span {
    color: #051d39;
  }
`;

const DescriptionWrapper = styled.div`
  width: 100%;
  white-space: pre-line;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  button {
    width: 100%;
  }
`;
